"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangesControl = exports.DefaultExchanges = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Copyright (c) 2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Sebastian Bittrich <sebastian.bittrich@rcsb.org>
 */
const React = tslib_1.__importStar(require("react"));
const common_1 = require("molstar/lib/mol-plugin-ui/controls/common");
const validation_1 = require("./validation");
exports.DefaultExchanges = new Map([
    ['ALA', 'Alanine'],
    ['CYS', 'Cysteine'],
    ['ASP', 'Aspartic Acid'],
    ['GLU', 'Glutamic Acid'],
    ['PHE', 'Phenylalanine'],
    ['GLY', 'Glycine'],
    ['HIS', 'Histidine'],
    ['ILE', 'Isoleucine'],
    ['LYS', 'Lysine'],
    ['LEU', 'Leucine'],
    ['MET', 'Methionine'],
    ['ASN', 'Asparagine'],
    ['PRO', 'Proline'],
    ['GLN', 'Glutamine'],
    ['ARG', 'Arginine'],
    ['SER', 'Serine'],
    ['THR', 'Threonine'],
    ['VAL', 'Valine'],
    ['TRP', 'Tryptophan'],
    ['TYR', 'Tyrosine'],
    ['DA', 'Deoxyadenosine'],
    ['DC', 'Deoxycytidine'],
    ['DG', 'Deoxyguanosine'],
    ['DT', 'Deoxythymidine'],
    ['A', 'Adenosine'],
    ['C', 'Cytidine'],
    ['G', 'Guanosine'],
    ['U', 'Uridine'],
]);
class ExchangesControl extends React.Component {
    constructor() {
        super(...arguments);
        this.onClickSwatch = (e) => {
            const tlc = e.currentTarget.getAttribute('data-id');
            this.props.handler.toggleExchange(tlc);
            // this makes Chrome pick up CSS change
            e.currentTarget.blur();
        };
    }
    swatch() {
        const out = [];
        exports.DefaultExchanges.forEach((v, k) => {
            const isSelected = this.props.handler.hasExchange(k);
            const className = isSelected ? 'msp-control-current' : '';
            const isDisabled = this.props.handler.exchanges.size >= validation_1.MAX_EXCHANGES && !isSelected;
            out[out.length] = (0, jsx_runtime_1.jsx)(common_1.Button, { title: v, inline: true, "data-id": k, onClick: this.onClickSwatch, style: { padding: 0, fontSize: '13px' }, className: className, disabled: isDisabled, children: k && isSelected ? (0, jsx_runtime_1.jsx)("b", { children: k }) : k }, k);
        });
        return (0, jsx_runtime_1.jsx)("div", { className: 'msp-combined-color-swatch', children: out });
    }
    render() {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: 'msp-control-offset', children: this.swatch() }) });
    }
}
exports.ExchangesControl = ExchangesControl;
